import axios from 'axios';

const api = '/api/payments';

export const getImportedPaymentById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const createImportedPayment = (companyId, data) => {
  return axios.post(`${api}?companyId=${companyId}&cacheBuster=${new Date().getTime()}`, data);
};

export const updateImportedPayment = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const evaluateImportedPayment = (id, data) => {
  return axios.put(`${api}/evaluate/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const createAndEvaluateImportedPayment = (companyId, data) => {
  return axios.post(`${api}/evaluate/${companyId}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateImportedPaymentContract = (importedPaymentId, contractId) => {
  return axios.put(`${api}/change-contract/${importedPaymentId}/${contractId}?cacheBuster=${new Date().getTime()}`);
};

export const addContractPayment = (id, contract) => {
  return axios.post(`${api}/add-contract/${id}?cacheBuster=${new Date().getTime()}`, contract);
};

export const updateContract = (id, contract) => {
  return axios.put(`${api}/update-contract/${id}?cacheBuster=${new Date().getTime()}`, contract);
};

export const deletePaymentContract = id => {
  return axios.delete(`${api}/delete-payment-contract/${id}?cacheBuster=${new Date().getTime()}`);
};

export const deleteImportedPayment = id => {
  return axios.delete(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};
